/** ============================================================
 * tree.js — Árbol de Cadena Evolution Link (v2 — conexiones correctas)
 * Cada nodo está conectado a su padre mediante líneas SVG.
 * NO existen ramas flotantes — la jerarquía es siempre visible.
 * ============================================================ */

const BO_TREE = {

    ESTATUS_COLORS: {
        activo:       '#22C55E',
        blanco:       '#22C55E',
        blanca:       '#22C55E',
        inactivo:     '#6b7280',
        gris:         '#6b7280',
        seguimiento:  '#F59E0B',
        amarillo:     '#F59E0B',
        baja:         '#EF4444',
        rojo:         '#EF4444',
        nuevo:        '#60A5FA',
    },

    LEVEL_COLORS: ['#3B82F6','#60A5FA','#93C5FD','#BFDBFE','#DBEAFE'],

    GAL_ICONS: { acero:'⬡', plata:'◈', oro:'★', diamante:'◆' },

    /**
     * Renderiza el árbol dentro del contenedor dado.
     * @param {string} containerId
     * @param {Object} rootNode — { id, nombre, apellido, rol, estatus, frontales_activos, galardon, hijos/children: [...] }
     */
    render(containerId, rootNode) {
        const container = document.getElementById(containerId);
        if (!container) return;
        container.innerHTML = '';
        container.style.cssText = 'overflow:auto;padding:2rem 1rem;';

        // Normalize children field
        const norm = (node) => ({
            ...node,
            children: (node.hijos || node.children || []).map(norm),
        });
        const root = norm(rootNode);

        // Compute positions using a simple layout algorithm
        const nodeW = 148, nodeH = 140, gapX = 28, gapY = 72;
        let xCounter = 0;

        // First pass: assign x positions (leaf → parent centering)
        const assignX = (node) => {
            const kids = node.children;
            if (!kids.length) {
                node._x = xCounter++;
                return;
            }
            kids.forEach(assignX);
            node._x = (kids[0]._x + kids[kids.length - 1]._x) / 2;
        };
        assignX(root);

        // Second pass: collect all nodes with their level
        const allNodes = [];
        const traverse = (node, level, parent) => {
            allNodes.push({ node, level, parent });
            node.children.forEach(child => traverse(child, level + 1, node));
        };
        traverse(root, 0, null);

        const totalCols = xCounter;
        const maxLevel = Math.max(...allNodes.map(n => n.level));

        const svgW = totalCols * (nodeW + gapX) + gapX;
        const svgH = (maxLevel + 1) * (nodeH + gapY) + gapY;

        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('width', svgW);
        svg.setAttribute('height', svgH);
        svg.style.cssText = 'position:absolute;top:0;left:0;pointer-events:none;';

        const wrap = document.createElement('div');
        wrap.style.cssText = `position:relative;width:${svgW}px;height:${svgH}px;min-width:max-content;`;
        wrap.appendChild(svg);

        // Draw connection lines first (so they appear behind cards)
        allNodes.forEach(({ node, level, parent }) => {
            if (!parent) return;

            const px = parent._x * (nodeW + gapX) + gapX + nodeW / 2;
            const py = (level - 1) * (nodeH + gapY) + gapY + nodeH;
            const cx = node._x * (nodeW + gapX) + gapX + nodeW / 2;
            const cy = level * (nodeH + gapY) + gapY;

            const color = this.LEVEL_COLORS[level] || '#374151';
            const mid = py + (cy - py) / 2;

            // Line: from parent bottom → elbow → child top
            const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            path.setAttribute('d', `M ${px} ${py} L ${px} ${mid} L ${cx} ${mid} L ${cx} ${cy}`);
            path.setAttribute('stroke', color);
            path.setAttribute('stroke-width', '1.8');
            path.setAttribute('fill', 'none');
            path.setAttribute('stroke-opacity', '0.55');
            path.setAttribute('stroke-linecap', 'round');
            svg.appendChild(path);
        });

        // Draw node cards
        allNodes.forEach(({ node, level }) => {
            const x = node._x * (nodeW + gapX) + gapX;
            const y = level * (nodeH + gapY) + gapY;
            const color = this.LEVEL_COLORS[level] || '#374151';
            const estatusColor = this.ESTATUS_COLORS[node.estatus] || '#71717A';
            const initials = ((node.nombre||'?')[0] + ((node.apellido||'')[0] || '')).toUpperCase();
            const frontales = node.frontales_activos || node.frontales || 0;
            const galIcon = this.GAL_ICONS[node.galardon] || '';
            const galLabel = node.galardon ? `${galIcon} LED ${node.galardon.toUpperCase()}` : '';

            const card = document.createElement('div');
            card.style.cssText = `
                position:absolute;
                left:${x}px; top:${y}px;
                width:${nodeW}px; height:${nodeH}px;
                background:rgba(24,24,27,.95);
                border:1.5px solid ${color};
                border-radius:12px;
                display:flex; flex-direction:column; align-items:center; justify-content:center;
                gap:4px; padding:10px 8px; text-align:center;
                cursor:pointer; transition:transform .18s, box-shadow .18s;
                box-sizing:border-box;
            `;
            card.onmouseenter = () => {
                card.style.transform = 'translateY(-3px)';
                card.style.boxShadow = `0 8px 28px rgba(29,78,216,.35)`;
            };
            card.onmouseleave  = () => {
                card.style.transform = 'none';
                card.style.boxShadow = 'none';
            };
            card.onclick = () => {
                const input = document.getElementById('treeRootId');
                if (input) {
                    input.value = node.id;
                    if (typeof loadTree === 'function') loadTree();
                }
            };
            card.title = `Click para ver la cadena de #${node.id} ${node.nombre || ''}`;

            // Status dot
            const dot = document.createElement('div');
            dot.style.cssText = `position:absolute;top:7px;right:7px;width:7px;height:7px;border-radius:50%;background:${estatusColor};box-shadow:0 0 5px ${estatusColor};`;
            if (node.estatus === 'amarillo') dot.style.animation = 'pulse-s 2s infinite';

            // Level badge
            if (level > 0) {
                const lvl = document.createElement('div');
                lvl.style.cssText = `position:absolute;top:7px;left:7px;font-size:.58rem;font-weight:800;color:${color};text-transform:uppercase;letter-spacing:.05em;`;
                lvl.textContent = `N${level}`;
                card.appendChild(lvl);
            }

            // Galardón
            if (galLabel) {
                const gal = document.createElement('div');
                gal.style.cssText = 'font-size:.58rem;color:#94A3B8;text-transform:uppercase;letter-spacing:.04em;margin-bottom:1px;';
                gal.textContent = galLabel;
                card.appendChild(gal);
            }

            // Avatar
            const av = document.createElement('div');
            av.style.cssText = `width:36px;height:36px;border-radius:50%;background:linear-gradient(135deg,${color},#DC2626);display:flex;align-items:center;justify-content:center;font-weight:800;font-size:.85rem;color:#fff;flex-shrink:0;`;
            av.textContent = initials;

            // Name
            const nm = document.createElement('div');
            nm.style.cssText = 'font-weight:700;font-size:.75rem;color:#fff;line-height:1.2;';
            nm.textContent = `${node.nombre||''} ${(node.apellido||'')[0]||''}.`;

            // ID
            const id = document.createElement('div');
            id.style.cssText = 'font-size:.65rem;color:#71717A;';
            id.textContent = `#${node.id}`;

            // Frontales badge
            const fb = document.createElement('div');
            fb.style.cssText = `font-size:.65rem;font-weight:700;padding:2px 7px;border-radius:100px;background:${frontales>=5?'rgba(34,197,94,.12)':'rgba(245,158,11,.12)'};color:${frontales>=5?'#22C55E':'#F59E0B'};`;
            fb.textContent = `${frontales} frontales`;

            card.appendChild(dot);
            card.appendChild(av);
            card.appendChild(nm);
            card.appendChild(id);
            card.appendChild(fb);
            wrap.appendChild(card);
        });

        container.appendChild(wrap);
    },

    /**
     * Generate mock tree data for demo/development
     */
    generateMock(rootId = 1001) {
        return {
            id: rootId, nombre: 'Ana', apellido: 'García',
            rol: 'cliente', estatus: 'blanco', frontales_activos: 7, galardon: 'acero',
            hijos: [
                {
                    id: rootId+1, nombre: 'Luis', apellido: 'Martínez',
                    estatus: 'blanco', frontales_activos: 5, galardon: 'acero',
                    hijos: [
                        { id: rootId+10, nombre: 'Karla', apellido: 'Ríos', estatus: 'blanco', frontales_activos: 2,
                          hijos: [
                            { id: rootId+100, nombre: 'Pedro', apellido: 'Soto', estatus: 'nuevo', frontales_activos: 0, hijos: [] }
                          ]
                        },
                        { id: rootId+11, nombre: 'Jorge', apellido: 'Castro', estatus: 'gris', frontales_activos: 1, hijos: [] },
                    ]
                },
                {
                    id: rootId+2, nombre: 'María', apellido: 'López',
                    estatus: 'amarillo', frontales_activos: 2, galardon: null,
                    hijos: [
                        { id: rootId+20, nombre: 'Sofía', apellido: 'Ruiz', estatus: 'nuevo', frontales_activos: 0, hijos: [] },
                        { id: rootId+21, nombre: 'Diana', apellido: 'Flores', estatus: 'blanco', frontales_activos: 3, hijos: [] },
                    ]
                },
                {
                    id: rootId+3, nombre: 'Carlos', apellido: 'Pérez',
                    estatus: 'blanco', frontales_activos: 6, galardon: 'acero',
                    hijos: [
                        { id: rootId+30, nombre: 'Héctor', apellido: 'Vega',  estatus: 'gris',   frontales_activos: 0, hijos: [] },
                        { id: rootId+31, nombre: 'Nadia',  apellido: 'Cruz',  estatus: 'blanco',  frontales_activos: 1, hijos: [] },
                    ]
                },
                {
                    id: rootId+4, nombre: 'Elena', apellido: 'Torres',
                    estatus: 'blanco', frontales_activos: 11, galardon: 'plata',
                    hijos: [
                        { id: rootId+40, nombre: 'Omar',   apellido: 'Ibarra', estatus: 'blanco', frontales_activos: 5, hijos: [] },
                        { id: rootId+41, nombre: 'Valeria',apellido: 'Mora',   estatus: 'blanco', frontales_activos: 3, hijos: [] },
                    ]
                },
            ]
        };
    }
};
